// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_la-0";